import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/common/Seo';

const ApplicationSuccessPage = () => {
    return (
        <div className="w-full min-h-screen bg-[#F9F9FB] flex items-center justify-center px-4">
            <Seo
                title="Application Submitted | Agastya Agro Limited"
                description="Your application is with us. Explore more Agastya Agro opportunities while our hiring team reviews your profile."
                noIndex
            />
            <div className="max-w-[600px] w-full bg-white rounded-[24px] shadow-lg p-8 md:p-10 text-center">
                <div className="w-20 h-20 mx-auto mb-6 bg-green-100 rounded-full flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                </div>

                <h1 className="font-[LTWave] font-medium text-2xl md:text-3xl mb-4">
                    Application Submitted Successfully!
                </h1>

                <p className="font-inter text-gray-600 mb-8">
                    Thank you for your interest in joining our team. We have received your application and will review it shortly.
                    Our team will contact you if your qualifications match our requirements.
                </p>

                <div className="flex flex-col md:flex-row gap-4 justify-center">
                    <Link
                        to="/career"
                        className="bg-black text-white font-inter font-medium px-6 py-3 rounded-[21.26px] transition-all duration-300 hover:bg-gray-800 no-underline"
                    >
                        Explore More Jobs
                    </Link>

                    <Link
                        to="/"
                        className="bg-white text-black border border-black font-inter font-medium px-6 py-3 rounded-[21.26px] transition-all duration-300 hover:bg-gray-100 no-underline"
                    >
                        Back to Home
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default ApplicationSuccessPage;
